import { useDroppable } from '@dnd-kit/core';
import { Button, Card, CardContent, Stack, Typography, alpha } from '@mui/material';
import React from 'react';
import ksimStudents from '../assets/ksim-students2.png';
import ClassroomStudentList from '../classroom-student-list/ClassroomStudentList';
import Fallback from '../fallback/Fallback';
import { ClassroomStudent } from '../types';

export interface ClassroomStudentsProps {
  allAssigned: boolean;
  onAssignAll: () => void;
  onUnassignAll: () => void;
  students: ClassroomStudent[];
}

const ClassroomStudents = ({ allAssigned, onAssignAll, onUnassignAll, students }: ClassroomStudentsProps) => {
  const { active, isOver, setNodeRef } = useDroppable({ id: 'students' });

  const activeInList = students.find(student => student.id === active?.id);

  return (
    <Card
      ref={setNodeRef}
      sx={theme => ({
        backgroundColor:
          !activeInList && isOver ? alpha(theme.palette.primary.main, 0.15) : theme.palette.background.default,
        overflow: 'visible',
        position: 'sticky',
        top: 64,
      })}
    >
      <CardContent>
        <Typography component="h2" variant="h5" gutterBottom>
          Students
        </Typography>
        {students.length ? (
          <>
            <Stack direction="row" mb={2}>
              {allAssigned ? (
                <Button variant="outlined" onClick={() => onUnassignAll()} sx={{ flex: 1 }}>
                  Unassign all
                </Button>
              ) : (
                <Button variant="outlined" onClick={() => onAssignAll()} sx={{ flex: 1 }}>
                  Assign all
                </Button>
              )}
            </Stack>
            <ClassroomStudentList students={students} />
          </>
        ) : (
          <Stack alignItems="center" spacing={3}>
            <Fallback imgSrc={ksimStudents} message="All students have been assigned" />
            <Button variant="outlined" onClick={() => onUnassignAll()} sx={{ flex: 1 }}>
              Unassign all
            </Button>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default ClassroomStudents;
